import { DataSeries } from '@next/core-lib/models';
import { createReducer, on } from '@ngrx/store';

import {
  ObservationsRegistration,
  WithinCyclePerformanceState,
} from '../../models/within-cycle-performance.model';

import * as actions from './../actions/within-cycle-performance.actions';

export const initialState: WithinCyclePerformanceState = <WithinCyclePerformanceState>{
  selectedCycleId: undefined,
  selectedbarnId: undefined,
  refValueSheetDataSeries: undefined,
  wdoDataSeries: undefined,
  observations: undefined,
};

export const withinCyclePerformanceReducer = createReducer<WithinCyclePerformanceState>(
  initialState,
  on(actions.loadRefValSheetDataSeriesSuccess, (state, { refValSheetDataSeries }) => ({
    ...state,
    refValueSheetDataSeries: refValSheetDataSeries,
  })),
  on(actions.loadRefValSheetDataSeriesError, (state) => ({
    ...state,
    refValueSheetDataSeries: undefined as DataSeries<number, number>,
  })),
  on(actions.loadWdoDataSeriesSuccess, (state, { wdoDataSeries }) => ({
    ...state,
    wdoDataSeries,
  })),
  on(actions.loadWdoDataSeriesError, (state) => ({
    ...state,
    wdoDataSeries: undefined as DataSeries<number, number>[],
  })),
  on(actions.loadObservationsForCycleSuccess, (state, { observations }) => ({
    ...state,
    observations: [...observations].sort((o) => o.intervalValue),
    selectedWeekNr: getLatestWeek(observations),
  })),
  on(actions.loadObservationsForCycleFailed, (state) => ({
    ...state,
    observations: [] as ObservationsRegistration[],
  })),
  on(actions.upsertObservationsForCycleSuccess, (state, { observations }) => ({
    ...state,
    observations: [
      ...(state.observations ?? []).filter(
        (so) =>
          observations.findIndex(
            (o) =>
              o.intervalType === so.intervalType &&
              o.intervalValue === so.intervalValue &&
              o.cycleId === so.cycleId,
          ) < 0,
      ),
    ]
      .concat(observations)
      .sort((o) => o.intervalValue),
    selectedWeekNr: getLatestWeek(observations),
  })),
  on(actions.loadGrowthPredictionDataSeriesSuccess, (state, { growthPredictionDataSeries }) => ({
    ...state,
    growthPredictionDataSeries,
  })),
  on(actions.loadGrowthPredictionDataSeriesError, (state) => ({
    ...state,
    growthPredictionDataSeries: undefined as DataSeries<number, number>[],
  })),
);

export function getLatestWeek(observations: ObservationsRegistration[]) {
  return observations.length > 0
    ? (Math.max(...observations.map((o) => o.intervalValue)) + 1) / 7
    : 0;
}
